import React from 'react';
import styled from '@emotion/styled';
// import { useNavigate } from 'react-router-dom';
import { mqUser } from 'utils/responsive';
import LogoImg from 'ui/images/logo.svg';
import IconLinkImg from 'ui/images/top/icon_newtab.svg';

const Footer = styled.footer`
    width: 100%;
    background-color: var(--dark-blue);
    padding: 38px 0;
`;

const Logo = styled.img`
    width: 128px;
    margin: 0 auto 20px auto;
`;

const Nav = styled.nav`
    text-align: center;
`;

const Link = styled.a`
    color: #fff;
    text-decoration: none;
    font-size: 0.875rem; /*14px*/
    font-weight: 400;
    margin-right: 20px;

    &:visited,
    &:active {
        color: #fff;
    }

    &:after {
        content: '';
        display: inline-block;
        width: 14px;
        height: 14px;
        background-image: url(${IconLinkImg});
        background-repeat: no-repeat;
        background-size: contain;
        margin-left: 5px;
    }

    ${mqUser('NARROW')} {
        font-size: 0.8125rem; /*13px*/
        margin-right: 32px;
    }
`;

export const TopFooter = () => {
    // const navigate = useNavigate();

    return (
        <Footer>
            <Logo src={LogoImg} alt="MAny" />
            <Nav>
                <Link href="/terms/" target="_blank">
                    利用規約
                </Link>
                <Link href="/privacy/" target="_blank">
                    プライバシーポリシー
                </Link>
                <Link href="/company_profile/" target="_blank">
                    運営会社
                </Link>
            </Nav>
        </Footer>
    );
};
